import CreateUpdatePaymentForm from "./Forms/CreateUpdatePaymentForm";
import usePaymentsApi from "../../hooks/usePaymentsApi";
import { Button, Form, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
import React from "react";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdEdit } from "react-icons/md";

interface CreateUpdatePaymentPropsTypes {
  id?: ID;
  refetch?: any;
}

export default function CreateUpdatePayment(
  props: CreateUpdatePaymentPropsTypes,
): React.ReactElement {
  const { id, refetch } = props;
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { payment: data, getPayment } = usePaymentsApi(id);

  useEffect(() => {
    if (id && isModalVisible) {
      getPayment({
        variables: {
          id: id,
        },
      });
    }
  }, [isModalVisible]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleOk = () => {
    form.submit();
  };

  return (
    <>
      {id ? (
        <TooltipButton placement="top" handleOnClick={showModal} icon={<MdEdit />} />
      ) : (
        <Row justify="end" className="margin-top">
          <Button type="primary" onClick={showModal}>
            {t("Add")}
          </Button>
        </Row>
      )}

      <Modal
        title={id ? t("Update payment") : t("Add payment")}
        open={isModalVisible}
        onOk={handleOk}
        okText={t("Save")}
        okButtonProps={{
          icon: (
            <span className="anticon">
              <FaSave />
            </span>
          ),
        }}
        onCancel={handleCancel}
        width={768}
        className="antd-modal"
      >
        <CreateUpdatePaymentForm
          data={data}
          form={form}
          refetch={refetch}
          setIsModalVisible={setIsModalVisible}
          id={id}
        />
      </Modal>
    </>
  );
}
